import { httpClient } from '../httpClient/httpClient';

export interface CalculatePricingRequest {
  productGroupId: number;
  branchIds: number[];
  tierRangeId: number;
  templateId: number;
  labelWidth: number;
  labelHeight: number;
}

export interface RegionPrice {
  regionId: number;
  regionName: string;
  purchasePrice: number;
  salePrice: number;
}

export interface TierRange {
  id: number;
  name: string;
  startRange: number;
  endRange: number;
}

export interface VdcPricing {
  template: any;
  totalArea: number;
  tierRange: TierRange;
  regionPrices: RegionPrice[];
}

export const vdcApi = {
  calculatePricing: (request: CalculatePricingRequest) =>
    httpClient.post<VdcPricing>(`vdc/pricing`, { data: request }),
};
